import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import moment from "moment";
// import Button from "../../../../components/buttons/buttons";
import ReviewKYCModal from "../../../../components/modals/admin/reviewKYC";
import { showABusinessVerification } from "../../../../redux/businessVerification/businessVerificationActions";

export default function BusinessKYCUserDetails() {
  const dispatch = useDispatch();
  // const navigate = useNavigate();
  const params = useParams();

  const { singleVerification } = useSelector(
    (state) => state.businessVerification
  );

  useEffect(() => {
    if (params?.id) {
      dispatch(showABusinessVerification(params?.id));
    }
    // eslint-disable-next-line
  }, [params?.id]);

  return (
    <div data-test="singleOrder-page">
      <div className="border border-[#E4E4F3] dark:border-none bg-white dark:bg-[#121212] rounded-md py-5 px-4 sm:px-8">
        <div className="border-b border-[#E4E4F3] py-3 flex justify-between items-center">
          <h3 className="text-lg font-medium">User Details</h3>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-5 gap-4 sm:gap-8 mt-6">
          <div>
            <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">Name</label>
            <p className="text-[#151515] dark:text-white text-sm font-bold">
              {singleVerification?.user?.name}
            </p>
          </div>
          <div>
            <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">Gender</label>
            <p className="text-[#151515] dark:text-white text-sm font-bold">
              {singleVerification?.user?.gender}
            </p>
          </div>
          <div>
            <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">Email</label>
            <p className="text-[#151515] dark:text-white text-sm font-bold">
              {singleVerification?.user?.email}
            </p>
          </div>
          <div>
            <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">Phone number</label>
            <p className="text-[#151515] dark:text-white text-sm font-bold">
              {singleVerification?.user?.phone}
            </p>
          </div>

          <div>
            <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">Date Created</label>
            <p className="text-[#151515] dark:text-white text-sm font-bold">
              {moment(singleVerification?.user?.created_at).format(
                "MMM DD, YYYY"
              )}
            </p>
          </div>
          <div>
            <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">Registration No:</label>
            <p className="text-[#151515] dark:text-white text-sm font-bold">
              {singleVerification?.document_number}
            </p>
          </div>

          <div>
            <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">Country</label>
            <p className="text-[#151515] dark:text-white text-sm font-bold">
              {singleVerification?.user?.country}
            </p>
          </div>
          <div>
            <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">City</label>
            <p className="text-[#151515] dark:text-white text-sm font-bold">
              {singleVerification?.user?.city}
            </p>
          </div>
          <div>
            <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">State</label>
            <p className="text-[#151515] dark:text-white text-sm font-bold">
              {singleVerification?.user?.state}
            </p>
          </div>
        </div>
      </div>

      <div className="border border-[#E4E4F3] dark:border-none bg-white dark:bg-[#121212] rounded-md py-5 px-4 sm:px-8 mt-8">
        <div className="border-b border-[#E4E4F3] py-3 flex justify-between items-center">
          <h3 className="text-lg font-medium">KYC Status</h3>
          {/* <Button.Primary title={"Review Status"} /> */}
          <ReviewKYCModal singleVerification={singleVerification} />
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 sm:gap-8 mt-6">
          <div>
            <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">Status</label>
            <p className="text-[#151515] dark:text-white text-sm font-bold">
              {singleVerification?.status}
            </p>
          </div>
          <div>
            <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">Comment: </label>
            <p className="text-[#151515] dark:text-white text-sm font-bold">
              {singleVerification?.comment}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
